import { spreadObject } from 'common/libs/spreadObject'
import { createContext, useEffect, useState } from 'react'
import ThemeManager from 'theming/ThemeManager'

let CustomThemeContext

const { Provider } = (CustomThemeContext = createContext())

const CustomThemeProvider = ({ children }) => {
  const [themeController, setThemeController] = useState(new ThemeManager())

  useEffect(() => {
    fetch('/assets/resources/tema.json')
      .then((res) => {
        return res.json()
      })
      .then((data) => {
        const storedTheme = localStorage.getItem('theme') || 'light'

        const activePallete = themeController.activePallete()

        const customPalette =
          storedTheme === 'light' ? (data.pallete.Light ?? null) : (data.pallete.Dark ?? null)

        const spreadPalette = spreadObject(activePallete, customPalette)

        const newPalette = customPalette ? spreadPalette : activePallete

        setThemeController({
          ...themeController,
          ...{
            pallete: newPalette,
            activeTheme: {
              ...themeController.activeTheme,
              components_styles:
                themeController?.get_components_styles(newPalette) ??
                themeController?.activeTheme?.components_styles,
            },
            typography: themeController?.typography,
            hide: data.hide ? { ...themeController?.hide, ...data.hide } : themeController?.hide,
            options: data.options
              ? { ...themeController?.options, ...data.options }
              : themeController?.options,
            cssVariables: true,
          },
        })
      })
  }, [])

  return (
    <Provider
      value={{
        themeController: themeController,
      }}
    >
      {children}
    </Provider>
  )
}

export { CustomThemeContext, CustomThemeProvider }
